import React, { Component } from "react";
import "../../styles/ConverterConfig.css";
import "../../styles/switchbutton.css";
import { GT_ParamsName } from "../../Utilities/converterparamscnf.js";
import { GT_Params_LABEL } from "../../Utilities/converterparamscnf.js";
import { GT_Params_NOTCH } from "../../Utilities/converterparamscnf.js";
import { GT_Params_VACIO } from "../../Utilities/converterparamscnf.js";
import { GT_Labels, GT_Seam_Allowance_Quality, GT_Notch } from "../../Utilities/converterparamscnf.js";

import { currentLocals } from "../../languages/languages.js";
import ConfigParam from "../../containers/ConfigParamContainer";

import { AddIcon } from "@lectra/mui-library-icons";

import { Select, MenuItem, FormControl, FormLabel, Checkbox } from "@mui/material";
import { MuiLectraButton } from "@lectra/mui-library";
import { Typography } from "@mui/material";

export default class ConverterConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paramName: "",
      paramSufix: "",
      paramSufixList: [],
      paramSelected: "",
    };
  }

  handleChangeMultipleMdl = (event, id) => {
    const { updateConverterMultipleMdl } = this.props;
    updateConverterMultipleMdl({ id: id, multiplemdl: event.target.checked });
  };
  handleOnChangeParam(event) {
    let ParamName = event.target.value;
    this.setState({ paramSufixList: GT_Params_VACIO });
    this.setState({ paramName: ParamName });
    this.setState({ paramSufix: currentLocals(this.props.locale).converter.SelectParameterSufix });
    if (ParamName === "GT_LABEL") {
      this.setState({ paramSufixList: GT_Params_LABEL });
    } else if (ParamName === "NOTCH" || ParamName === "NOTCH_IS_EXTERNAL") {
      this.setState({ paramSufixList: GT_Params_NOTCH });
    }
  }
  handleOnChangeParamSufix(event) {
    let ParamSufix = event.target.value;
    this.setState({ paramSufix: ParamSufix });
  }
  handleAdd() {
    const { setConfigParam } = this.props;
    let { converterconfig } = this.props;
    let defaultparamvalue = "";

    if (this.state.paramSufix === currentLocals(this.props.locale).converter.SelectParameterSufix) {
      this.state.paramSufix = "";
    }

    if (this.state.paramName !== "") {
      if (
        (this.state.paramName === "GT_LABEL" ||
          this.state.paramName === "NOTCH" ||
          this.state.paramName === "NOTCH_IS_EXTERNAL") &&
        this.state.paramSufix === ""
      ) {
        //param sufix required
      } else {
        if (this.state.paramName === "GT_LABEL") defaultparamvalue = GT_Labels[0];
        else if (this.state.paramName === "SEAM_ALLOWANCE_VALUE") defaultparamvalue = "0.0";
        else if (this.state.paramName === "FABRIC_REPEAT_X") defaultparamvalue = "0.0";
        else if (this.state.paramName === "FABRIC_REPEAT_Y") defaultparamvalue = "0.0";
        else if (this.state.paramName === "SEAM_ALLOWANCE_QUALITY") defaultparamvalue = GT_Seam_Allowance_Quality[0];
        else if (this.state.paramName === "COMPUTE_QUALITY_ZONE") defaultparamvalue = "NO";
        else if (this.state.paramName === "AUTO_CLOSE_QUALITY_ZONE_DISTANCE") defaultparamvalue = "0.0";
        else if (this.state.paramName === "NOTCH") defaultparamvalue = GT_Notch[3];
        //We put "IFGF_LINE_TOOL_PLOT", as default
        else if (this.state.paramName === "NOTCH_IS_EXTERNAL") defaultparamvalue = "NO";
        let paramid = "";
        if (this.state.paramName !== "") {
          paramid = this.state.paramName;
          if (this.state.paramSufix !== "") paramid = paramid + "_" + this.state.paramSufix;
        }

        if (converterconfig.hasOwnProperty(paramid)) {
          //alert("exist!!");
        } else {
          setConfigParam({
            converterid: this.props.converterIdent,
            convertertype: this.props.converterType,
            paramid: paramid,
            paramvalue: defaultparamvalue,
          });
          document.getElementById("SelectParameter").setAttribute("defaultvalue", "NOTCH");
          document.getElementById("SelectParameter").setAttribute("value", "NOTCH");
        }
      }
    }
    this.setState({ paramSufix: currentLocals(this.props.locale).converter.SelectParameterSufix });
  }
  render() {
    //It must be different, depending on the type of converter; Accumark, aama-astm...
    let { converterconfig } = this.props;
    let { converters } = this.props;

    let isMultipleMDL = false;
    isMultipleMDL = true;
    let i = 0;
    while (i < converters.length) {
      if (converters[i].id === this.props.converterIdent) isMultipleMDL = converters[i].multiplemdl;
      i++;
    }
    if (!isMultipleMDL) isMultipleMDL = false;
    else isMultipleMDL = true;

    //We will only show the parameters that have not been used
    let GT_ParamsInConverter = [];
    GT_ParamsInConverter = Object.keys(converterconfig);
    let GT_ParamsNameToShow = GT_ParamsName.filter((item) => !GT_ParamsInConverter.includes(item));

    // We will only show the suffixes of parameters that have not been used.

    let GT_LABEL_ParamsInConverter = [];
    let NOTCH_ParamsInConverter = [];
    let NOTCH_IS_EXTERNAL_ParamsInConverter = [];

    Object.keys(converterconfig).forEach((key) => {
      const prefix = key.split("_").slice(0, -1).join("_");
      if (prefix === "GT_LABEL") {
        GT_LABEL_ParamsInConverter.push(key.split("_").pop());
      } else if (prefix === "NOTCH") {
        NOTCH_ParamsInConverter.push(key.split("_").pop());
      } else if (prefix === "NOTCH_IS_EXTERNAL") {
        NOTCH_IS_EXTERNAL_ParamsInConverter.push(key.split("_").pop());
      }
    });

    //by default
    let paramSufixListToShow = this.state.paramSufixList;
    if (this.state.paramName === "GT_LABEL")
      paramSufixListToShow = this.state.paramSufixList.filter((item) => !GT_LABEL_ParamsInConverter.includes(item));
    if (this.state.paramName === "NOTCH")
      paramSufixListToShow = this.state.paramSufixList.filter((item) => !NOTCH_ParamsInConverter.includes(item));
    if (this.state.paramName === "NOTCH_IS_EXTERNAL")
      paramSufixListToShow = this.state.paramSufixList.filter(
        (item) => !NOTCH_IS_EXTERNAL_ParamsInConverter.includes(item)
      );
    //document.getElementById("SelectParameter").setAttribute("value", {valuePlaceHolderParameter});
    let valuePlaceHolderParameter = currentLocals(this.props.locale).converter.SelectParameter;
    let valuePlaceHolderParameterSufix = currentLocals(this.props.locale).converter.SelectParameterSufix;
    return (
      <div>
        <div>
          <Checkbox
            id="multiplemdl"
            checked={isMultipleMDL}
            onChange={(event) => this.handleChangeMultipleMdl(event, this.props.converterIdent)}
          ></Checkbox>
          <FormLabel sx={{ m: 1, width: 350 }}>
            <Typography variant="body2" sx={{ color: "black", opacity: 0.87 }}>
              {currentLocals(this.props.locale).converter.MultipleMDL}
            </Typography>
          </FormLabel>
        </div>
        <div>
          <FormControl sx={{ m: 1, width: 350 }}>
            {/*
            <InputLabel id="label-select-parameter" size="small" variant="standard">
              {currentLocals(this.props.locale).converter.SelectParameter}
           </InputLabel>*/}
            <Select
              id="SelectParameter"
              defaultValue={valuePlaceHolderParameter}
              onChange={(event) => this.handleOnChangeParam(event)}
            >
              <MenuItem disabled value={valuePlaceHolderParameter}>
                <em>{currentLocals(this.props.locale).converter.SelectParameter}</em>
              </MenuItem>
              {GT_ParamsNameToShow.map((param) => (
                <MenuItem value={param}>{param}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              m: 1,
              width: {
                display:
                  this.state.paramName === "GT_LABEL" ||
                  this.state.paramName === "NOTCH" ||
                  this.state.paramName === "NOTCH_IS_EXTERNAL"
                    ? 150
                    : 0,
              },
            }}
          >
            <Select
              sx={{ m: 0, width: 150 }}
              defaultValue={valuePlaceHolderParameterSufix}
              value={this.state.paramSufix}
              onChange={(event) => this.handleOnChangeParamSufix(event)}
              style={{
                display:
                  this.state.paramName === "GT_LABEL" ||
                  this.state.paramName === "NOTCH" ||
                  this.state.paramName === "NOTCH_IS_EXTERNAL"
                    ? ""
                    : "none",
              }}
            >
              {/* {this.state.paramSufixList.map((param) => (
                <MenuItem value={param}>{param}</MenuItem>
              ))}
              */}
              <MenuItem disabled value={valuePlaceHolderParameterSufix}>
                <em>{currentLocals(this.props.locale).converter.SelectParameterSufix}</em>
              </MenuItem>
              {paramSufixListToShow.map((param) => (
                <MenuItem value={param}>{param}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, width: 200 }}>
            <MuiLectraButton
              kind="primary"
              startIcon={<AddIcon></AddIcon>}
              onClick={() => {
                this.handleAdd();
              }}
            >
              {currentLocals(this.props.locale).configparams.AddConfigParam}
            </MuiLectraButton>
          </FormControl>
        </div>
        <br></br>
        <div
          className="results-body ConverterConfigBodyEmpty"
          id="resultsbodyEmpty"
          style={{ display: Object.keys(converterconfig).length > 0 ? "none" : "block" }}
        >
          <div className="ConverterConfigBodyEmpty Description">
            {currentLocals(this.props.locale).converter.NoParameterYet}
          </div>
        </div>
        <FormLabel
          style={{
            display: Object.keys(converterconfig).length > 0 ? "" : "none",
          }}
          sx={{ m: 1, width: 350 }}
        >
          {" "}
          <Typography variant="body2" sx={{ color: "black", opacity: 0.54 }}>
            {currentLocals(this.props.locale).configparams.Parameter}
          </Typography>
        </FormLabel>
        <FormLabel
          style={{
            display: Object.keys(converterconfig).length > 0 ? "" : "none",
          }}
          sx={{ m: 1, width: 150 }}
        >
          <Typography variant="body2" sx={{ color: "black", opacity: 0.54 }}>
            {currentLocals(this.props.locale).configparams.Value}
          </Typography>
        </FormLabel>

        {Object.keys(converterconfig).map((key, index) => (
          <div
            className={key === this.state.paramSelected ? "rowselected" : ""}
            onClick={() => {
              this.setState({ paramSelected: key });
            }}
          >
            <ConfigParam
              index={index}
              sizeconverterconfig={Object.keys(converterconfig).length}
              converterid={this.props.converterIdent}
              convertertype={this.props.converterType}
              paramName={key}
              paramValue={converterconfig[key]}
              key={key}
            ></ConfigParam>
          </div>
        ))}
      </div>
    );
  }
}
